import Pagination from 'js-pagination';
import _ from 'lodash';
// import {$} from "../../../../../../wp-includes/js/backbone";

export default class SolutionsFilterBarSearch {
	constructor(el) {
		this.el = el;
		this.searchEl = this.el.querySelector('.solutions-filter-bar-search-input');
		this.taxonomyFilterEls = this.el.querySelectorAll('.solutions-spsx-taxonomy-filter');
		this.dateFilterEls = this.el.querySelectorAll('.solutions-spsx-date-filter');
		this.searchAction = this.el.dataset.action;
		this.searchType = this.el.dataset.type;
		this.resultsContainerEl = document.getElementById('solutions-filter-bar-results');
		this.searchEl.addEventListener('keyup', _.debounce(() => {
			this.handleFilteredSearch()
		}, 500));
		this.paginationEl = document.getElementById('solutions-pagination');
		this.resultsCountEl = document.getElementById('solutions-results-count');
		this.hostname = window.location.hostname;
		this.path = window.location.pathname;
		this.searchQueryDescriptor = document.getElementById('search-query-descriptor');
		this.searchQueryValue = document.getElementById('search-query-value');

		this.multiSelectBtnEls = this.el.querySelectorAll('.solutions-multiselect-container');
		this.multiSelectEls = this.el.querySelectorAll('.solutions-multiselect');
		this.filterButtonsEl = document.getElementById('solutions-filters');
		this.filterChips = this.el.querySelectorAll('.solutions-filter-tab');
		this.filtersClearEl = document.getElementById('solutions-search-chip-clear');
		this.searchChip = document.getElementById('solutions-search-chip');
		this.pathParams = new URLSearchParams(window.location.search)
		this.prepopulated = !!this.pathParams;

		// Check if we're on the "all" resources page
		this.showAllResources = this.path.includes('/resources/all/');

		for (const multiEl of this.multiSelectBtnEls) {
			multiEl.addEventListener('click', function (e) {
				if ('block' === this.querySelector('.solutions-multiselect-group').style.display) {
					this.querySelector('.solutions-multiselect-group').style.display = 'none';
				} else {
					for (const multiEl of document.querySelectorAll('.solutions-multiselect-group')) {
						multiEl.style.display = 'none';
					}
					this.querySelector('.solutions-multiselect-group').style.display = 'block';
				}
			})
		}
		const filterButtonEvent = () => (event) => {
			let filter = event.srcElement.id;
			document.getElementById('select-' + filter).checked = false
			event.srcElement.style.display = 'none';

			let paramKey = filter.split(/-(.*)/s)[0]
			let paramValue = filter.split(/-(.*)/s)[1]
			this.pathParams.delete(paramKey, paramValue)
			this.handleFilteredSearch()

		}

		for (const multiEl of this.filterChips) {
			multiEl.addEventListener('click', filterButtonEvent())
		}

		const searchClearEvent = () => (event) => {
			this.searchEl.value = ''
			event.srcElement.style.display = 'none';
			this.handleFilteredSearch()
		}

		const clearFilters = () => (event) =>{
			for(const select of this.multiSelectEls) {
				select.checked = false
			}
			for (const chip of this.filterChips) {
				chip.style.display = 'none'
			}
			this.searchEl.value = ''
			this.searchChip.style.display = 'none';
			this.pathParams = new URLSearchParams();
			history.pushState(null, '', (this.pathParams.toString()))
			this.handleFilteredSearch()
		}

		this.searchChip.addEventListener('click', searchClearEvent())
		this.filtersClearEl.addEventListener('click', clearFilters())

		const checkboxUpdate = () => (event) => {
			if (event.srcElement.checked === false) {
				let chipID = event.srcElement.id.slice(7)
				document.getElementById(chipID).style.display = 'none'
				let filter = chipID;
				let paramKey = filter.split(/-(.*)/s)[0]
				let paramValue = filter.split(/-(.*)/s)[1]
				this.pathParams.delete(paramKey, paramValue)
			}
		}

		for (const multiEl of this.multiSelectEls) {
			multiEl.addEventListener('click', checkboxUpdate())
		}

		if (this.resultsCountEl) {
			if (this.paginationEl) {
				console.log(this.paginationEl.dataset.results)
				this.resultsCountEl.innerHTML = this.paginationEl.dataset.results;
			}
		}

		if (this.paginationEl) {
			this.totalResults = this.paginationEl.dataset.results;
			this.ipp = this.paginationEl.dataset.ipp;
		}

		this.page = 1;

		for (const taxEl of this.taxonomyFilterEls) {

			taxEl.addEventListener('change', _.debounce(() => {
				this.handleFilteredSearch()
			}, 500), true);
		}

		for (const multiEl of this.multiSelectEls) {

			multiEl.addEventListener('change', _.debounce(() => {
				this.handleFilteredSearch()
			}, 500));
		}

		for (const dateEl of this.dateFilterEls) {
			dateEl.addEventListener('change', _.debounce(() => {
				this.handleFilteredSearch()
			}, 500));
		}

		if (this.paginationEl) {
			if (window.innerWidth >= 768) {
				Pagination.config({
					lang: 'en',
					adjacent: 3
				});
			} else {
				Pagination.config({
					lang: 'en',
					adjacent: 1
				});
			}
			this.setupPagination();
		}

		if (this.path.includes('category')) {
			this.search(true)
		}

		if (this.pathParams) {
			this.search(true)
		}
	}

	/**
	 * Gets number of Posts while filtering
	 */
	resultsCount() {
		if (this.resultsCountEl) {
			this.resultsCountEl.innerHTML = this.totalResults;
		}
	}


	/**
	 * Gets values for any dropdown taxonomy filters in this filter bar
	 */
	getTaxonomyFilters(filterData) {
		for(const el of this.taxonomyFilterEls) {
			if (el.value) {
				let filterName = el.name;
				filterData[filterName] = el.value;
			}
		}
		for(const el of this.dateFilterEls) {
			let filterName = el.name;
			filterData[filterName] = el.value;
		}
		return filterData;
	}

	getMultiTaxonomyFilters(filterData) {
		for(const el of this.multiSelectEls) {
			if (el.checked) {
				let filterName = el.getAttribute("data-id");
				if (!filterData[filterName]) {
					filterData[filterName] = [];
				}
				if (!filterData[filterName].includes(el.value))
				filterData[filterName].push(el.value);
			}
		}
		return filterData;
	}

	getPathFilters(path, filterData) {
		let filterName = path[0]
		filterData[filterName] = path.slice(-1)[0]
		return filterData;
	}

	handleFilteredSearch() {
		this.pathParams.delete('search')
		this.search(true);
	}

	handleUpdateFilters(filterData) {
		let filterEls = this.filterButtonsEl.querySelectorAll('.solutions-filter-tab');
		let filters = [];
		for (const data in filterData)  {

			for (const filter in filterData[data] ) {
				if (data === 'search') {
					filters.push('solutions-search-chip')
				} else {
					filters.push((data + '-' + filterData[data][filter]))
				}

			}
		}

		let filterElIds =[];
		filterEls.forEach(function(el) {
			filterElIds.push(el.id)
		})

		filters.forEach((filter) => {
			document.getElementById(filter).style.display = 'inline';
			if (!filterElIds.includes(filter)) {
				document.getElementById(filter).style.display = 'inline';
			}
		})

	}

	updatePathFromFilters(filterData) {
		// Get current URL parameters
		this.pathParams = new URLSearchParams(window.location.search);
		
		// Check if 'all=true' parameter exists
		const hasAllParam = this.pathParams.has('all') && this.pathParams.get('all') === 'true';
		
		// Clear existing params but preserve 'all' if it exists
		const allParam = hasAllParam ? 'true' : null;
		this.pathParams = new URLSearchParams();
		if (allParam) {
			this.pathParams.set('all', allParam);
		}

		// Add filter parameters
		for (const [key, value] of Object.entries(filterData)) {
			if (Array.isArray(value)) {
				for (const v of value) {
					this.pathParams.append(key, v);
				}
			} else {
				this.pathParams.append(key, value);
			}
		}

		history.pushState(null, '', ('?' + this.pathParams.toString()));
	}

	/**
	 * Run search
	 */
	search(setupPagination = false) {
		// Get Taxonomy filters
		let filterData = {};
		if (this.path.includes('category')) {
			let setupPagination = true;
			let pathVars = this.path.split('/').filter(Boolean);
			filterData = this.getPathFilters(pathVars, filterData);
		}
		if (this.prepopulated) {
			for (const [key, value] of this.pathParams) {
				// Skip the 'all' parameter for filter data
				if (key === 'all') continue;
				
				if (!filterData[key]) {
					filterData[key] = [];
				}
				if (!filterData[key].includes(value)) {
					filterData[key].push(value);
				}
				if (key === 'search') {
					this.searchEl.value = value;
				} else {
					const selectEl = document.getElementById('select-' + key + '-' + value);
					if (selectEl) selectEl.checked = true;
				}
			}
		}

		filterData = this.getMultiTaxonomyFilters(filterData);
		// filterData = this.getTaxonomyFilters(filterData);

		this.handleUpdateFilters(filterData)
		this.updatePathFromFilters(filterData)
		// Add Action
		filterData.action = this.searchAction;

		// Search Query
		filterData.search_query_request = this.searchEl.value;
		if (filterData.search_query_request.length > 0) {
			// Make sure we're not duplicating the search parameter
			this.pathParams.delete('search');
			this.pathParams.append('search', filterData.search_query_request);
			history.pushState(null, '', ('?' + this.pathParams.toString()));
		}
		
		// Type of search
		filterData.type = this.searchType;

		// Set Page
		filterData.selected_page = this.page;
		
		// Check if 'all' parameter is in URL and pass it to the AJAX request
		filterData.show_all = this.pathParams.has('all');

		// Show search query
		if (filterData.search_query_request) {
			this.searchQueryDescriptor.style.display = "inline";
			this.searchQueryValue.style.display = "inline";
			this.searchQueryValue.innerText = filterData.search_query_request;
			this.searchChip.style.display = "inline";
			this.searchChip.innerText = 'keyword: ' + filterData.search_query_request;
		} else {
			this.searchQueryDescriptor.style.display = "none";
			this.searchQueryValue.style.display = "none";
			this.searchChip.style.display = "none";
		}


		jQuery(this.resultsContainerEl)
			.empty()
			.html("<div class='please_wait'>Please wait...</div>");

		jQuery.ajax
		({
			url         : SPSXCore.ajaxurl,
			//dataType    : "html",
			type        : "POST",
			dataType    : "json",
			data        : filterData,
			success: (data) => {
				jQuery(this.resultsContainerEl).html(data.html);
				this.totalResults = data.total;

				if(setupPagination) {
					this.setupPagination();
				}
				this.resultsCount();
			}
		});
	}

	setupPagination() {
		// Skip pagination setup if all=true is in the URL
		if (this.pathParams.has('all')) {
			return;
		}
		
		// Only proceed with pagination setup if the element exists
		if (!this.paginationEl) {
			return;
		}
		
		this.pagination = {};
		this.paginationEl.innerHTML = '';
		this.paginationEl.innerHTML = '<div id="pagination-wrapper"></div>';
		this.pagination = new Pagination(this.totalResults, this.ipp, (page) => { this.pageSelect(page) }, '#pagination-wrapper');
	}

	pageSelect(page) {
		this.page = page.current;
		window.scroll({
			top: 0,
			left:0,
			behavior: 'smooth'
		});
		this.search(false);
	}
};